var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "domain-autocomplete", style: { width: _vm.width } },
    [
      _c(
        "flex-grid",
        { attrs: { "align-items": "center" } },
        [
          _c(
            "flex-grid-item",
            { attrs: { grow: "1", margin: "10px" } },
            [
              _c("autocomplete", {
                attrs: {
                  "empty-hint": "Start typing to search for a domain.",
                  focus: _vm.focus,
                  height: _vm.height,
                  "is-loading": _vm.isLoading,
                  options: _vm.domainList,
                  placeholder:
                    "" + (_vm.domain ? _vm.domain : "cadence-canary"),
                  search: _vm.search
                },
                on: {
                  change: _vm.onAutocompleteChange,
                  search: _vm.onAutocompleteSearch
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("flex-grid-item", { attrs: { width: "32px" } }, [
            !_vm.navigateToDomainUrl
              ? _c("span", { staticClass: "navigate-to-domain disabled" })
              : _vm._e(),
            _vm._v(" "),
            _vm.navigateToDomainUrl
              ? _c("a", {
                  staticClass: "navigate-to-domain",
                  attrs: { href: _vm.navigateToDomainUrl }
                })
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-596ce728", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596ce728","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/domain-autocomplete/component.vue
// module id = 1543
// module chunks = 0